module.exports = __webpack_public_path__ + "img/slide-0.f9a9e445.jpg";